var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadmapicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 151 131",
    width: 151,
    height: 131,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_1901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 131,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_1901)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,38.257999420166016,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.15599822998047,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,68.0530014038086,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,82.9469985961914,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,97.84400177001953,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,112.74400329589844,1.0160000324249268)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,30.81100082397461,13.881999969482422)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2050175666809082,0,0,1.2050175666809082,45.70500183105469,13.881999969482422)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.29499816894531,13.881999969482422)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.19000244140625,13.881999969482422)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,23.361000061035156,26.746000289916992)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,38.257999420166016,26.746000289916992)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,112.74199676513672,26.746000289916992)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5899648666381836,0,0,3.5899648666381836,15.911999702453613,39.61199951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,30.81100082397461,39.61199951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,45.70500183105469,39.61199951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,75.48100280761719,39.88600158691406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,68.03399658203125,26.48200035095215)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,90.37799835205078,39.88600158691406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,82.93099975585938,26.48200035095215)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.19000244140625,39.61199951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7949824333190918,0,0,1.7949824333190918,8.463000297546387,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5899648666381836,0,0,3.5899648666381836,23.361000061035156,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,38.25600051879883,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,53.15599822998047,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,82.93099975585938,52.750999450683594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,97.8270034790039,52.750999450683594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,127.63899993896484,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.0160000324249268,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7949824333190918,0,0,1.7949824333190918,15.911999702453613,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5899648666381836,0,0,3.5899648666381836,30.81100082397461,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,45.70500183105469,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,60.604000091552734,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,74.7249984741211,65.34400177001953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,67.35299682617188,52.60900115966797)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,59.97999954223633,39.20600128173828)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,52.60900115966797,27.14299964904785)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,60.650001525878906,13.73900032043457)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,75.39600372314453,13.73900032043457)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,90.14099884033203,13.73900032043457)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,97.51399993896484,27.14299964904785)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,104.88500213623047,39.875999450683594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,112.25800323486328,52.60900115966797)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,119.62699890136719,65.34400177001953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,111.58799743652344,78.0770034790039)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,104.88500213623047,90.81099700927734)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,97.51399993896484,103.54399871826172)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,90.14099884033203,116.2770004272461)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,74.7249984741211,116.2770004272461)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,59.97999954223633,116.2770004272461)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,52.60900115966797,103.54399871826172)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,59.97999954223633,90.81099700927734)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6025087833404541,0,0,0.6025087833404541,67.35299682617188,78.0770034790039)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-2.3454999923706055 C1.2944813966751099,-2.3454999923706055 2.3454999923706055,-1.2944813966751099 2.3454999923706055,0 C2.3454999923706055,1.2944813966751099 1.2944813966751099,2.3454999923706055 0,2.3454999923706055 C-1.2944813966751099,2.3454999923706055 -2.3454999923706055,1.2944813966751099 -2.3454999923706055,0 C-2.3454999923706055,-1.2944813966751099 -1.2944813966751099,-2.3454999923706055 0,-2.3454999923706055z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,90.37799835205078,65.61699676513672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,105.2760009765625,65.61699676513672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,135.08799743652344,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7949824333190918,0,0,1.7949824333190918,8.463000297546387,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5899648666381836,0,0,-3.5899648666381836,23.361000061035156,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,38.25600051879883,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,53.15599822998047,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,82.77799987792969,78.14900207519531)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,97.52300262451172,78.14900207519531)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,127.63899993896484,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5899648666381836,0,0,-3.5899648666381836,15.911999702453613,93.10600280761719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,30.81100082397461,93.10600280761719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,45.70500183105469,93.10600280761719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,74.73500061035156,91.5530014038086)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,90.14900207519531,91.5530014038086)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.19000244140625,93.10600280761719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6849932670593262,0,0,1.6849932670593262,127.63899993896484,26.746000289916992)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,135.08799743652344,39.61199951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,142.53700256347656,52.47800064086914)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,149.98399353027344,65.34300231933594)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,142.53700256347656,80.23999786376953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,135.08799743652344,93.10600280761719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,127.63899993896484,105.97100067138672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4,0,0,4,23.361000061035156,105.97100067138672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4100351333618164,0,0,2.4100351333618164,38.257999420166016,105.97100067138672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,67.36399841308594,104.28700256347656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25,0,0,0.25,82.77799987792969,104.28700256347656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-4.366499900817871 C2.4098713397979736,-4.366499900817871 4.366499900817871,-2.4098713397979736 4.366499900817871,0 C4.366499900817871,2.4098713397979736 2.4098713397979736,4.366499900817871 0,4.366499900817871 C-2.4098713397979736,4.366499900817871 -4.366499900817871,2.4098713397979736 -4.366499900817871,0 C-4.366499900817871,-2.4098713397979736 -2.4098713397979736,-4.366499900817871 0,-4.366499900817871z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,112.74199676513672,105.97100067138672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,30.81100082397461,118.83599853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2050175666809082,0,0,1.2050175666809082,45.70500183105469,118.83599853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.29499816894531,118.83599853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,120.19000244140625,118.83599853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,38.257999420166016,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,53.15599822998047,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,68.0530014038086,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,82.9469985961914,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,97.84400177001953,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,112.74400329589844,131.70199584960938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M0,-1.0154999494552612 C0.5604544281959534,-1.0154999494552612 1.0154999494552612,-0.5604544281959534 1.0154999494552612,0 C1.0154999494552612,0.5604544281959534 0.5604544281959534,1.0154999494552612 0,1.0154999494552612 C-0.5604544281959534,1.0154999494552612 -1.0154999494552612,0.5604544281959534 -1.0154999494552612,0 C-1.0154999494552612,-0.5604544281959534 -0.5604544281959534,-1.0154999494552612 0,-1.0154999494552612z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapicon);
export default __webpack_public_path__ + "static/media/roadmapicon.96c726cfd6bbc20d6ae7fc5d25c49fb4.svg";
export { ForwardRef as ReactComponent };